<template>
  <smallModal @escape="$emit('close')">
    <h5>{{ lang["restore"] }}</h5>
    <hr />
    <div>
      <label :for="newCompanyName">{{ lang["DoYouWantRestore"] }} {{ newCompanyName }}?</label>
    </div>
    <div v-if="ccc">
      <div class="buttons-flex-end">
        <button @click="getCaptcha" class="btn">
          <b-icon-arrow-repeat id="captcha-leave"></b-icon-arrow-repeat>
        </button>
      </div>
      <div class="imgDiv">
        <img :src="ccc" class="capImg">
      </div>
      <label :for="captchaName">{{ lang["EnterCaptcha"] }}</label>
      <b-form-input v-model="cap.captcha" :state="capState" :name="captchaName" autofocus />
    </div>
    <label :for="accountPassword">{{ lang["Password"] }}</label>
    <b-form-input v-model="accountPassword" type="password" :state="passState" :name="accountPassword" />
    <hr />
    <div class="buttons">
      <button class="btn btn-secondary" @click="$emit('close')">{{ lang["Сancel"] }}</button>
      <button class="btn btn-success" @click="save" :disabled="!(passState && capState)">{{ lang["Proceed"] }}</button>
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { rotate } from '../js/rotateBtn'; // Імпортуємо функцію rotate для обертання елемента на 180 градусів з анімацією
import { guid } from '../js/guid.js'; // Імпортуємо функцію guid для створення унікальних ідентифікаторів
import { regAPi } from '@/API.js';
import smallModal from "../modals/smallModal"; // Компонент маленького модального вікна

const apiList = new regAPi();

export default {
  props: ["targetCompany"],
  components: {
    smallModal,
  },
  data() {
    return {
      cap: {
        captcha: "",
        captcha_guid: "",
      },
      accountPassword: "",
      ccc: null,
      captchaName: `captcha_${Math.floor(Math.random() * (99999 - 999 + 1) + 999)}`,
      newCompanyName: "",
    };
  },
  mounted() {
    console.log(this.targetCompany);
    this.newCompanyName = this.targetCompany.company_name;
    keyevent.$off('enter');
    keyevent.$on('enter', this.save);
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      try {
        const captchaGuid = guid();
        const captchaUrl = apiList.captchaUID(captchaGuid);
        this.ccc = captchaUrl;
        this.cap.captcha_guid = captchaGuid;
        rotate("#captcha-leave");
        this.cap.captcha = '';
      } catch (err) {
        console.log(err);
      }
    },
    save() {
      if (this.passState && this.capState) {
        const data = {
          password: this.accountPassword,
          ...this.cap,
          company_id: this.targetCompany.company_id,
        };
        console.log(this.targetCompany.company_id);
        this.$emit("save", data);
      } else {
        window.say.messageError(this.lang['Password']);
      }
    },
  },
  computed: {
    passState() {
      return this.accountPassword.length >= 4;
    },
    capState() {
      return this.cap.captcha.length === 4;
    },
    // Мова додатку
    lang() {
      return window.lang;
    },
  },
};
</script>

<style scoped>
.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-success, .btn-success.disabled, .btn-success:disabled {
  background-color: #00c279;
  border: none;
  font-size: 10pt;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-secondary {
  background-color: gray;
  color: white;
  border: none;
  font-size: 10pt;
}

/* .btn-secondary:not(:disabled):not(.disabled):active {
  background-color: white;
  color: gray;
}

.btn-secondary:hover {
  text-decoration: underline;
  color: gray;
  background-color: white;
} */

.imgDiv {
  text-align: center;
  height: 100px;
}

.capImg {
  height: 100px;
}

.buttons-flex-end {
  display: flex;
  justify-content: flex-end;
}

#captcha-leave {
  height: 2rem;
  width: 2rem;
}
</style>